import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Navbar from "./Navbar";

const getPageTitle = (pathname) => {
  const routes = {
    '/': 'Dashboard',
    '/schedule': 'Smart Schedule Finder',
    '/schedule/previous': 'Previous Requests',
    '/waitlist': 'Waitlist Autopilot',
    '/embed': 'Fast Book Banner',
    '/data-status': 'Data Status',
    '/billing': 'Billing',
    '/availability': 'Availability',
    '/onboarding': 'Onboarding',
    '/onboarding/connect-provider': 'Connect Provider',
    '/onboarding/connect-jobber': 'Connect Provider',
    '/onboarding/waitlist': 'Waitlist Custom Field',
    '/onboarding/waitlist/customize': 'Customize Your Waitlist',
    '/onboarding/availability': 'Set Availability',
  };

  // Check for exact match first
  if (routes[pathname]) {
    return routes[pathname];
  }

  // Check for partial matches (e.g., /schedule/previous/123)
  for (const [route, title] of Object.entries(routes)) {
    if (pathname.startsWith(route) && route !== '/') {
      return title;
    }
  }

  return 'Dashboard';
};

export default function Layout({ user }) {
  const location = useLocation();

  useEffect(() => {
    const pageTitle = getPageTitle(location.pathname);
    document.title = `Same Day Openings | ${pageTitle}`;
  }, [location.pathname]);

  return (
    <div className="min-h-screen bg-slate-50">
      <Navbar user={user} />
      <main className="mx-auto">
        <Outlet context={{ user }} />
      </main>
    </div>
  );
}
